import React, { useState, useRef } from 'react';

const Contact = () => {

    return (
        <div className="page-content">
            <div className='contact-page'>
                <div className='contact-header'>
                    <h1>Contact Us</h1>
                </div>
                <div className='contact-greeting'>
                    <p>We’re interested in what you have to say – about our products, our stores, our website. Tell us the good stuff and the not-so-good stuff (we can take it…your feedback only makes us better.) You can contact us using any of these options:</p>
                </div>
                <div className='contact-details'>
                    <div>
                        <p>Customer Experience Centre <a href="tel:+18889482337">1-888-948-2337</a> or <a href="mailto:customerservice@thebeerstore.ca">customerservice@thebeerstore.ca</a></p>
                    </div>
                    <div>
                        <p className='bold'>Hours of Operation:</p>
                    </div>
                    <div>
                        <p>Monday to Friday 8am – 8pm EST</p>
                    </div>
                    <div>
                        <p>Saturday to Sunday 9am – 5pm EST</p>
                    </div>
                    <div>
                        <p>Statutory Holidays – CLOSED</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;